import { fetchWrapper } from "../utils/fetch-wrapper";



const adressesService = {
    getAll,
    getById,
    post,
    update,
    delete: _delete,
    count
  };
  

  function getAll() {
    return fetchWrapper.get("adresses/");
  }
  
  function getById(id) {
    return fetchWrapper.get(`adresses/${id}`);
  }
  
  function post(data) {
    return fetchWrapper.post("adresses/", data);
  }
  
  function update(id, params) {
    return fetchWrapper.put(`adresses/${id}`, params);
  }
  
  function _delete(id) {
    return fetchWrapper.delete(`adresses/${id}`);
  }
  
  function count(){
    return fetchWrapper.get(`adresses/count`);
  }

  

  export default adressesService;